// extracted by mini-css-extract-plugin
export default {"gamesPage":"Games_gamesPage__vFjGz","gamesPage__container":"Games_gamesPage__container__YMTqW"};